/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import makeCancellablePromise from "./cancellablePromise";
import { LinkedList, Node } from "./LinkedListUtils";

let _promises = new LinkedList();

export const cancelAllPromises = () => {
  _promises.forEach(promise => {
    if (promise && promise.cancellablePromise)
      promise.cancellablePromise.cancel();
  });

  _promises = new LinkedList();
};

export const ajsMakeCancellablePromise = promise => {
  const cancellablePromise = makeCancellablePromise(promise);

  try {
    const node = new Node("cancellablePromise", cancellablePromise);
    _promises.insertNodeAtEnd(node);

    const removePromise = () => {
      _promises.removeNode(node);
    };
    cancellablePromise.promise.then(removePromise).catch(removePromise);
  } catch (e) {
    // continue regardless of error
  }
  return cancellablePromise.promise;
};
